var basSlugForAuthors = "experten";
var basSlugForMagazines = "magazine-ebooks";
var basSlugForArtikelSerien = "artikelserien";
import momentTimezone from 'moment-timezone';
import moment from 'moment';


export default {

    sandsConstructRealUrl: function(concordObject) {
    if (concordObject) {
        var relUrl = '#';

        if (concordObject && concordObject.__typename) {
            var typeNameOfConcordObject = concordObject.__typename;
            // console.log('typeNameOfConcordObject: ' + typeNameOfConcordObject);
            
            if (typeNameOfConcordObject == 'Brand') {
              if (concordObject.slug && concordObject.slug.length) {
                return '/' + basSlugForMagazines + '/' + concordObject.slug;
              }
            }
            if (typeNameOfConcordObject == 'Issue') {
              if (concordObject.slug && concordObject.slug.length) {
                if (concordObject.brand && concordObject.brand.slug && concordObject.brand.slug.length) {
                  return '/' + basSlugForMagazines + '/' + concordObject.brand.slug + '/' + concordObject.slug;
                }
              }
            }
            if (typeNameOfConcordObject == 'Conference') {
              if (concordObject.slug && concordObject.slug.length) {
                  return '/live-events/' + concordObject.marketingUrl;
              }
            }
            if (typeNameOfConcordObject == 'RecommendedEvent') {
              if (concordObject.slug && concordObject.slug.length) {
                  return '/live-events/' + concordObject.marketingUrl;
              }
            }
            if (typeNameOfConcordObject == 'Course') {
              if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'CONFERENCE') {
                return '/conferences/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'EA') {
                return '/trainings-seminars/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'TUTORIAL') {
                return '/tutorials' + concordObject.marketingUrl;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'CAMP') {
                return '/conferences/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length  && concordObject.genre && concordObject.genre === 'FSLE'){
                return '/live-events/' + concordObject.marketingUrl;
              }
              else if(concordObject.slug && concordObject.slug.length){
                return '/conferences/' + concordObject.slug;
              }
            }
            if (typeNameOfConcordObject == 'Author') {
                if (concordObject.slug && concordObject.slug.length) {
                    return "/" + basSlugForAuthors + '/' + concordObject.slug;
                }
            }
            if (typeNameOfConcordObject == 'Article') {
              if (concordObject.slug && concordObject.slug.length ) {
                // TODO:
                // check if we have archetypeArticle (clone) article
                // if yes use the archetypeArticle slug and archetypeArticle primary category 
                if (concordObject.archetypeArticle && concordObject.archetypeArticle.primaryCategory && 
                  concordObject.archetypeArticle.slug && concordObject.archetypeArticle.slug.length &&
                  concordObject.archetypeArticle.primaryCategory.slug && concordObject.archetypeArticle.primaryCategory.slug.length ) {
                  return '/' + concordObject.archetypeArticle.primaryCategory.slug + '/' + concordObject.archetypeArticle.slug;
                }
                // if no use normal slug and primary category
                else if (concordObject.primaryCategory && concordObject.primaryCategory.slug && concordObject.primaryCategory.slug.length ) {
                  return '/' + concordObject.primaryCategory.slug + '/' + concordObject.slug;
                }
              }
            }

            if (typeNameOfConcordObject == 'ArticleSeriesItem') {
              //console.log(concordObject);
              //console.log(concordObject.type);
              if (concordObject.type) {
                if (concordObject.slug && concordObject.slug.length) {
                  if (concordObject.type == 'COLUMN') {
                      if (concordObject.authors && concordObject.authors.length) {
                        if (concordObject.authors[0].slug && concordObject.authors[0].slug.length) {
                          return "/" + basSlugForAuthors + '/' + concordObject.authors[0].slug + '/' + concordObject.slug;
                        }
                      }
                  } else  if (concordObject.type == 'SERIES') {
                    //console.log(concordObject);
                    if (concordObject.articles && concordObject.articles.length) {
                      //console.log(2);
                      if (concordObject.articles[0].primaryCategory && concordObject.articles[0].primaryCategory.slug && concordObject.articles[0].primaryCategory.slug.length) {
                        return '/' + concordObject.articles[0].primaryCategory.slug + '/' + basSlugForArtikelSerien + '/' + concordObject.slug;
                      }
                    }
                  }
                }
              }
            }
        }
    }
    return relUrl;
    },

    hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
  
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },

    generateUrlForPocs(singlePoc) {
      if (singlePoc && singlePoc.schemaType && singlePoc.schemaType === 'ARTICLE') {
        if (singlePoc.categorySlug) {
          return `/${singlePoc.categorySlug.replace(/\s+/g, '-').toLowerCase()}/${singlePoc.slug}`;
        } else {
          return null;
        }
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        (singlePoc.parentGenre === 'CAMP' || singlePoc.parentGenre === 'RHEINGOLD' || singlePoc.parentGenre === 'FLEX')
      ) {
        return `/conferences/${singlePoc.parentSlug}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'TUTORIAL'
      ) {
        return `/tutorials${singlePoc.marketingUrl}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'FSLE'
      ) {
        return `/live-events${singlePoc.marketingUrl}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'COURSE'
      ) {
        return singlePoc?.marketingUrl ? `/kurse${singlePoc.marketingUrl}` : `/kurse`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'EA'
      ) {
        return `/trainings-seminars${singlePoc.parentSlug}`;
      }
      return null;
    },

    getCorrectPocType(parentGenre, parentSchemaType,pocSchemaType) {
      if (parentGenre === 'TUTORIAL') {
        return "Tutorial";
      }
      if (parentGenre === 'FSLE') {
        return "Live Event";
      }
      if (parentGenre === 'COURSE') {
        console.log("sands-render-app-context", window['sands_reader_app_context']);
        // setTimeout(() => {
        //   console.log("Delayed context:", window['sands_reader_app_context']);
        // }, 1000);
        if (window && window.walkuere_app_data?.isDevmioActive) {
            return "Course";
          }
          return "Kurs";
      }
      if (parentGenre === 'RHEINGOLD') {
        return "Session";
      }
      if (parentGenre === 'FLEX_CAMP') {
        return "Flex Camp";
      }
      if (parentGenre === 'CAMP') {
        return "Camp";
      }
      if (parentGenre === 'FLEX_CAMP' || parentGenre === 'CAMP') {
        if (parentSchemaType === 'COURSE') {
          return "Lesson";
        }
      }
      if (pocSchemaType) {
        return pocSchemaType.toString();
      }
      return "";
    },

    getUserLocalizeTime(localizeTime,timezone,format){
      let localTime;
      if (localizeTime && timezone) {
        if (moment(localizeTime, 'DD-MM-YYYY HH:mm:ss').isValid()){
          let tDateWithTimeZone = momentTimezone.tz(localizeTime, 'DD/MM/YYYY HH:mm:ss', timezone);
          let formatedStartdateTY = moment(tDateWithTimeZone['_d']).format('DD-MM-YYYY HH:mm:ss');
          let newFormatedStartdateTY = moment(formatedStartdateTY,'DD-MM-YYYY HH:mm:ss').toDate();
          let finalDate = moment(newFormatedStartdateTY).format(format);
          
          localTime = finalDate;
        }
      }
      
      return localTime;
     },
    
     getUserLocalizeTimeAsTime(localizeTime,timezone){
      let localTime;
      if (localizeTime && timezone) {
        if (moment(localizeTime, 'DD-MM-YYYY HH:mm:ss').isValid()){
          let tDateWithTimeZone = momentTimezone.tz(localizeTime, 'DD/MM/YYYY HH:mm:ss', timezone);
          let formatedStartdateTY = moment(tDateWithTimeZone['_d']).format('DD-MM-YYYY HH:mm:ss');
          let newFormatedStartdateTY = moment(formatedStartdateTY,'DD-MM-YYYY HH:mm:ss').toDate();
          
          localTime = newFormatedStartdateTY;
        }
      }
      
      return localTime;
     },
    
    convertSecondsToTime(timeInSec){
      if (timeInSec && timeInSec >= 3600) {
        return  moment.utc(timeInSec*1000).format('mm:ss');
      }else if(timeInSec){
        return  moment.utc(timeInSec*1000).format('HH:mm:ss');
      }
    }

}